<template>
  <div>
    <!-- <loading 
    :active.sync="isLoading" 
    :can-cancel="false" 
    :is-full-page="fullPage"
    :loader="loader"
    :color="color"
    :background-color="backgroundColor">
    </loading> -->
    <back-to-top visibleoffset="20" bottom="30px" right="10px">
        <button type="button" class="btn btn-primary btn-to-top"><i class="fa fa-chevron-up"></i></button>
    </back-to-top>
    <router-view></router-view>
  </div>
</template>
 
<script>
  // import Loading from 'vue-loading-overlay'
  // import { mapState } from 'vuex'
  import BackToTop from 'vue-backtotop'
  import {getUser} from '@/utils/auth'

  export default {
    data() {
      return {
        fullPage: true,
        color: '#1b8eb6',
        backgroundColor: 'buttonface',
        loader: 'dots',
      }
    },
    components: {
      // Loading,
      BackToTop
    },
    computed: {
      // ...mapState([
      //   'isLoading'
      // ])
    },
    name: 'app',
    created() {
      let email = getUser() && getUser().email_original ? getUser().email_original : (getUser() ? getUser().email : '');
      // console.log('email',email)
      window._paq.push(['setUserId', email]);
      this.$matomo && this.$matomo.trackPageView();
      this.$matomo && this.$matomo.enableLinkTracking();
      this.$matomo && this.$matomo.logAllContentBlocksOnPage();
    }
  }
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
